// extracted by LIB_CSS_EXTRACT_LOADER
import "./switch_module.css"
export default {"root":"root-MAgsb4","thumb":"thumb-UID9UK"};